/**
 * @type {{ [key: string]: import('$lib/utils/page').PageCondition }}
 */
const pageConditions = {
	default: {
		condition: async () => true,
		resolve: async () => await import('../_browser-2-0-rebrand/Page.svelte'),
	},
};

export { pageConditions };
